var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlugHouseholdASmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.1865234,4.7480469C27.8046875,4.2724609,27.2363281,4,26.6259766,4H5.3740234 C4.7636719,4,4.1953125,4.2724609,3.8154297,4.7470703C2.6679688,6.1708984,0,10.1171875,0,16 s2.6679688,9.8291016,3.8134766,11.2519531C4.1953125,27.7275391,4.7636719,28,5.3740234,28h21.2519531 c0.6103516,0,1.1787109-0.2724609,1.5585938-0.7470703C29.3320312,25.8291016,32,21.8828125,32,16 S29.3320312,6.1708984,28.1865234,4.7480469z M26.6259766,26L5.3720703,25.9990234C4.5810547,25.0166016,2,21.3925781,2,16 S4.5810547,6.9833984,5.3720703,6c0,0,0.0009766,0,0.0019531,0l21.2539062,0.0009766C27.4189453,6.9833984,30,10.6074219,30,16 S27.4189453,25.0166016,26.6259766,26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,10h-2c-1.1025391,0-2,0.8974609-2,2v8c0,1.1025391,0.8974609,2,2,2h2c1.1025391,0,2-0.8974609,2-2v-8 C14,10.8974609,13.1025391,10,12,10z M12,20h-2v-8h2V20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,10h-2c-1.1025391,0-2,0.8974609-2,2v8c0,1.1025391,0.8974609,2,2,2h2c1.1025391,0,2-0.8974609,2-2v-8 C24,10.8974609,23.1025391,10,22,10z M22,20h-2v-8h2V20z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugHouseholdASmall);
export default __webpack_public_path__ + "static/media/plug-household-a--small.f71e30a59db40a9c4b4479eadeecdbb9.svg";
export { ForwardRef as ReactComponent };